import ProductNav from '../../common/ProductNav';

export default function ExampleProductA() {
    return (
        <div>
            <ProductNav activeTab={'Media'} />
            media
        </div>
    );
}
